import React, { FC } from 'react';
import {
  Layout,
  TrustedByContractors,
  HeaderDescription,
  UtilityMenuBanner,
} from '../../v2/components/common';
import {
  AboutHover,
  TeamValuesSection,
  Hero,
  ProtectSection,
  AboutSections,
} from '../../v2/components/about-page';
import NewsLetterBar from '../../v2/components/common/news-letter-bar';

interface Props {}

const News: FC<Props> = () => (
  <Layout
    title="About HOVER | Meet the Team"
    description="At HOVER we’re building the future of 3D property data with a platform that lets anyone generate accurate 3D models by simply taking a few photos."
    isNavbarWhite={false}
    navbarBackgroundColor="brandGreen.500"
    bannerElement={<UtilityMenuBanner />}
  >
    <Hero />
    <HeaderDescription
      pt="84px"
      mb={{ base: 900, desktop: 0 }}
      heading="With a few smartphone photos you can get an interactive 3D model of any home."
      body="HOVER creates accurately-measured, customizable 3D models
      of homes from smartphone photos. Homeowners can visualize a
      project before they start, and pros save time and money while
       being more transparent and collaborative."
    />
    <AboutSections />
    <ProtectSection />
    <HeaderDescription
      pt={{ base: 700, tablet: 1000 }}
      pb={{ base: 700, desktop: 900 }}
      mb={200}
      heading="Our values"
      body="Guiding principles that inform not just what we do, but how we do it."
    />
    <TeamValuesSection />
    <AboutHover />
    <TrustedByContractors />
    <NewsLetterBar />
  </Layout>
);

export default News;
